export default __webpack_public_path__ + "static/media/teams.038efc3c.png";